export class StatusConstants {
    static readonly COMPLETED = 'COMPELETED';
    static readonly CANCELLED = 'CANCELLED';
    static readonly REQUEST = 'REQUEST';
    static readonly APPROVED = 'APPROVED';
    static readonly OUTTOBID = 'OUTTOBID';
    static readonly INPROGRESS = 'INPROGRESS';
    static readonly ONHOLD = 'ONHOLD';
}
